import { LEGAL_DOCS, LEGAL_NAV, BUSINESS_INFO, type LegalKind } from '../lib/legal.ts';

interface Props {
  kind: LegalKind;
}

export function LegalPage({ kind }: Props) {
  const doc = LEGAL_DOCS[kind] ?? LEGAL_DOCS.tos;
  return (
    <main className="nf-legal">
      <div className="nf-legal-inner">
        <aside className="nf-legal-nav">
          <div className="nf-legal-nav-label">법적 고지</div>
          <ul>
            {LEGAL_NAV.map((item) => (
              <li key={item.kind}>
                <a
                  href={`/legal/${item.kind}`}
                  className={item.kind === kind ? 'active' : ''}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </aside>
        <article className="nf-legal-article">
          <header className="nf-legal-head">
            <h1>{doc.title}</h1>
            {doc.subtitle && <p className="nf-legal-sub">{doc.subtitle}</p>}
            <p className="nf-legal-meta">시행일: {doc.lastUpdated}</p>
          </header>
          {doc.sections.map((section) => (
            <section key={section.title} className="nf-legal-section">
              <h2>{section.title}</h2>
              <p>{section.body}</p>
            </section>
          ))}
          {kind === 'business' && (
            <section className="nf-legal-section nf-legal-bizcard">
              <h2>요약</h2>
              <dl>
                <div>
                  <dt>상호</dt>
                  <dd>
                    {BUSINESS_INFO.companyName} ({BUSINESS_INFO.companyNameEn})
                  </dd>
                </div>
                <div>
                  <dt>대표자</dt>
                  <dd>{BUSINESS_INFO.representative}</dd>
                </div>
                <div>
                  <dt>사업자등록번호</dt>
                  <dd>{BUSINESS_INFO.bizNumber}</dd>
                </div>
                <div>
                  <dt>통신판매업 신고번호</dt>
                  <dd>{BUSINESS_INFO.mailOrderBizNumber}</dd>
                </div>
                <div>
                  <dt>사업장 주소</dt>
                  <dd>{BUSINESS_INFO.address}</dd>
                </div>
                <div>
                  <dt>업태 / 종목</dt>
                  <dd>
                    {BUSINESS_INFO.businessCategory} / {BUSINESS_INFO.businessItem}
                  </dd>
                </div>
                <div>
                  <dt>법인 형태</dt>
                  <dd>{BUSINESS_INFO.entityType}</dd>
                </div>
                <div>
                  <dt>과세 유형</dt>
                  <dd>{BUSINESS_INFO.taxType}</dd>
                </div>
                <div>
                  <dt>문의</dt>
                  <dd>
                    <a href={`mailto:${BUSINESS_INFO.inquiryEmail}`}>{BUSINESS_INFO.inquiryEmail}</a>
                  </dd>
                </div>
              </dl>
            </section>
          )}
        </article>
      </div>
    </main>
  );
}
